import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import Form from '../../../../../../form';
import Icon from '../../../../../Icon';
import { Grid, Typography, Menu, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { Field } from 'react-final-form';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles({
  icon: {
    fontSize: 16
  }
}, {
  name: 'ECFilterTopNDialog'
});

var FilterTopNDialog = function FilterTopNDialog(_ref) {
  var onClose = _ref.onClose,
      onChange = _ref.onChange,
      filter = _ref.filter,
      onRemove = _ref.onRemove;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      formatAnchorEl = _useState2[0],
      setFormatAnchorEl = _useState2[1];

  var classes = useStyles({});

  var handleCloseMenu = function handleCloseMenu() {
    setFormatAnchorEl(null);
  };

  var parseValues = function parseValues(filter) {
    if (filter === undefined) return {};
    var ruleParts = filter.rule.split(/\(|\)/g);
    var top = ruleParts[0] === 'top' ? ruleParts[1] : '';
    var format = '';

    if (top.endsWith('%')) {
      top = top.substring(0, top.length - 1);
      format = 'percent';
    }

    return {
      top: top,
      format: format,
      showOthers: filter.showOthers === 'True',
      othersLabel: filter.othersLabel
    };
  };

  var getFilter = function getFilter(_ref2) {
    var top = _ref2.top,
        format = _ref2.format,
        showOthers = _ref2.showOthers,
        othersLabel = _ref2.othersLabel;
    return {
      rule: "top(".concat(top).concat(format === 'percent' ? '%' : '', ")"),
      showOthers: showOthers ? 'True' : 'False',
      othersLabel: othersLabel
    };
  };

  return React.createElement(Form.Dialog, {
    onSuccess: function onSuccess(values) {
      onChange(getFilter(values));
      onClose();
    },
    windowProps: {
      onClose: onClose,
      style: {
        width: 600
      },
      header: 'Top N'
    },
    defaultValue: parseValues(filter),
    submitLabel: "OK",
    labelPlacement: "top",
    variant: "filled",
    hideCancelButton: true,
    renderFooterLeft: function renderFooterLeft() {
      return filter !== undefined && React.createElement(Icon, {
        className: classes.icon,
        onClick: onRemove,
        labelPlacement: "end",
        type: "delete",
        label: "Delete Filter"
      });
    },
    renderContent: function renderContent() {
      return React.createElement(Grid, {
        container: true,
        direction: "column",
        spacing: 2
      }, React.createElement(Grid, {
        item: true
      }, React.createElement(Typography, null, "Show only the first N records in this widget")), React.createElement(Grid, {
        item: true
      }), React.createElement(Grid, {
        item: true,
        container: true,
        alignItems: "center",
        spacing: 1
      }, React.createElement(Grid, {
        item: true,
        xs: 12
      }, React.createElement(Typography, null, "Top")), React.createElement(Grid, {
        item: true,
        xs: 4
      }, React.createElement(Form.Fields.Number, {
        required: true,
        margin: "none",
        name: "top",
        label: "",
        placeholder: "N"
      })), React.createElement(Grid, {
        item: true
      }, React.createElement(Field, {
        name: "format"
      }, function (_ref3) {
        var input = _ref3.input;
        return React.createElement(React.Fragment, null, React.createElement(Icon, {
          type: input.value === 'percent' ? 'percent-format' : 'number-format',
          className: classes.icon,
          onClick: function onClick(event) {
            return setFormatAnchorEl(event.currentTarget);
          },
          buttonSize: "small"
        }), React.createElement(Menu, {
          anchorEl: formatAnchorEl,
          keepMounted: true,
          open: Boolean(formatAnchorEl),
          onClose: handleCloseMenu
        }, React.createElement(MenuItem, {
          onClick: function onClick() {
            input.onChange('number');
            handleCloseMenu();
          }
        }, React.createElement(ListItemIcon, null, React.createElement(Icon, {
          type: "number-format",
          className: classes.icon
        })), React.createElement(ListItemText, {
          primaryTypographyProps: {
            variant: 'body2'
          }
        }, "Number")), React.createElement(MenuItem, {
          onClick: function onClick() {
            input.onChange('percent');
            handleCloseMenu();
          }
        }, React.createElement(ListItemIcon, null, React.createElement(Icon, {
          type: "percent-format",
          className: classes.icon
        })), React.createElement(ListItemText, {
          primaryTypographyProps: {
            variant: 'body2'
          }
        }, "Percent"))));
      }))), React.createElement(Grid, {
        item: true
      }, React.createElement(Typography, null, "Show Filtered Values as 'Others'"), React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, React.createElement(Grid, {
        item: true
      }, React.createElement(Form.Fields.Checkbox, {
        name: "showOthers",
        label: ""
      })), React.createElement(Grid, {
        item: true
      }, React.createElement(Field, {
        name: "showOthers"
      }, function (e) {
        return React.createElement(Form.Fields.Text, {
          name: "othersLabel",
          label: "",
          disabled: !e.input.value,
          placeholder: "Caption"
        });
      })))));
    }
  });
};

export default FilterTopNDialog;